import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { uuidish } from '../../utils/uuidish.js';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
/**
 * Validation rules for validating a veeva CRF.
 */
const veevaCaseReportFormValidationSchema = z.object({
    id: z.string().describe('id is required'),
    externalId: z.string().nullish().transform(nullishToUndefined).optional(),
    veevaStudyId: z.string().describe('veevaStudyId is required'),
    formDefinitionPrivateKey: z.string().describe('veevaFormDefinitionPrivateKey is required'),
    collectionName: z.string().describe('collectionName is required'),
    name: z.string().describe('name is required'),
    label: z.string(),
    shortLabel: z.string(),
    attributes: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    divisions: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    interventionTypes: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    regions: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    sponsors: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    studyPhases: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    therapeuticAreas: z.array(z.string()).nullish().transform(nullishToUndefined).optional(),
    tenantId: uuidish.describe('tenantId is required'),
    created: z.date().describe('created is required'),
});
export function toVeevaCaseReportForm(input) {
    const result = veevaCaseReportFormValidationSchema.safeParse(input);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid VeevaCaseReportForm object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=veeva-case-report-form.js.map